import { ReportBugComponent } from './report-bug.component';
import { FormsModule } from '@angular/forms';
import { I18nModule } from '../../template/shared/i18n/i18n.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ReportBugService } from './report-bug.service';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [
    ReportBugComponent
  ],
  imports: [
    ModalModule,
    FormsModule,
    I18nModule,
  ],
  exports: [
    ReportBugComponent
  ],
  providers: [
    ReportBugService
  ]
})

export class ReportBugModule {}